<template>
  <v-list-item three-line>
    <v-list-item-content>
      <v-row no-gutters>
        <v-list-item-title>{{ title }}</v-list-item-title>
        <v-list-item-subtitle class="py-2">
          Author:
          <b
            class="primary--text"
            style="cursor: pointer"
            @click="$emit('authorClick', full_name)"
          >{{ full_name }}</b>
        </v-list-item-subtitle>
        <v-list-item-subtitle>Created: {{ created_at }}</v-list-item-subtitle>
      </v-row>
    </v-list-item-content>
    <v-list-item-action>
      <v-row>
        <v-btn rounded text @click="show">
          show
          <v-icon right>mdi-open-in-new</v-icon>
        </v-btn>

        <v-btn
          color="primary"
          v-if="status != 'published'"
          rounded
          text
          @click="$emit('publish', uuid)"
        >
          Publish
          <v-icon right>mdi-eye</v-icon>
        </v-btn>
        <v-btn color="primary" v-else rounded text @click="$emit('unpublish', uuid)">
          Unpublish
          <v-icon right>mdi-eye-off</v-icon>
        </v-btn>
      </v-row>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  props: ["author", "created_at", "property_type", "uuid", "status", "title"],
  methods: {
    show() {
      this.$emit("show", this.uuid);
    }
  },
  computed: {
    full_name() {
      return this.author.first_name + " " + this.author.last_name;
    }
  }
};
</script>

<style lang="scss" scoped></style>
